// extracted by mini-css-extract-plugin
module.exports = {"emptyText":"ReceiptsStyles_emptyText__3Yjy_","receipt":"ReceiptsStyles_receipt__2RKGM","headButton":"ReceiptsStyles_headButton__u9aX4"};